import IMask from 'imask';
window.IMask = IMask;